import { OnrampApiError } from '../client.js';
import { fundingNavigationManifest } from '../generated/navigation.js';
import { FundingProviderError } from '../provider-error.js';
/** Only the documented sheet-dismissal event permits reusing a payment surface. */
export function paymentRecovery(next, hasAttempt, origin, hasQuoteContinuation, hasProviderTransaction = false) {
    const rules = fundingNavigationManifest.payment_recovery;
    if (next.phase === 'transaction_created')
        return rules.common.transaction_created;
    if (next.phase === 'widget_closed' || next.phase === 'provider_failed')
        return (hasProviderTransaction ? rules.with_transaction : rules.before_transaction)[next.phase];
    if (next.phase === 'ready' || next.phase === 'authorizing')
        return rules.common[next.phase];
    if (next.phase === 'challenge_required')
        return rules.common.challenge_required;
    if (next.phase === 'reconciling')
        return rules.common.reconciling;
    if (hasAttempt) {
        if (next.phase === 'second_factor_required')
            return rules.with_attempt.second_factor_required;
        if (next.phase === 'cancelled' && origin === 'payment')
            return rules.with_attempt.sheet_cancelled;
        if (next.phase === 'requote_required' && hasQuoteContinuation)
            return rules.with_attempt.requote_with_continuation;
        return rules.with_attempt.otherwise;
    }
    if (next.phase === 'requote_required' ||
        next.phase === 'session_refresh_required' ||
        next.phase === 'connection_required' ||
        next.phase === 'submission_unknown' ||
        next.phase === 'verification_pending')
        return rules.before_attempt[next.phase];
    return rules.before_attempt.otherwise;
}
/** A fresh session is safe only before any frame has received execution permission. */
export function canRefreshFundingSession(error, hasAttempt) {
    return (!hasAttempt &&
        ((error instanceof OnrampApiError && error.recovery === 'refresh_session') ||
            (error instanceof FundingProviderError && error.failure.code === 'unauthorized')));
}
